// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import MercariCampaign from '@/pages/mercari-campaign/components/_MercariCampaign.vue'

type MetaTag = {
	name?: string
	property?: string
	content: string
}

type MetaTags = {
	[key: string]: MetaTag
}

const ensureMetaTags = () => {
	const { head } = document
	const metaTags: MetaTags = {
		description: { name: 'description', content: '' },
		ogTitle: { property: 'og:title', content: '' },
		ogDescription: { property: 'og:description', content: '' },
		ogImage: { property: 'og:image', content: '' },
	}

	Object.entries(metaTags).forEach(([_, attributes]) => {
		const selector = attributes.name
			? `meta[name="${attributes.name}"]`
			: `meta[property="${attributes.property}"]`

		if (!document.querySelector(selector)) {
			const meta = document.createElement('meta')
			Object.entries(attributes).forEach(([attr, value]) => {
				if (value) {
					meta.setAttribute(attr, value)
				}
			})
			head.appendChild(meta)
		}
	})
}

hybridPage()

ensureMetaTags()

createApp({
	name: 'Mercari Campaign Page',
	components: {
		MercariCampaign,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.MercariIndex)

		const { mercariCampaignPageContent } = window.pageContent

		return {
			mercariCampaignPageContent,
		}
	},
}).mount('#bsMain')
